import { subject } from '@casl/ability';
import { Navigate, useParams } from 'react-router';
import ability from 'casl/ability';

export function determineStatusEntryPath() {
   if (!ability) {
      return '403';
   }
   if (ability.rules.length === 0) {
      return '';
   }

   if (ability.can('read', 'kpiArea')) {
      return '/status/key-figures';
   }

   if (ability.can('read', subject('footprint', {}))) {
      return '/status/emissions';
   }

   return '';
}

export function determineDashboardEntryPath() {
   if (!ability) {
      return '403';
   }

   if (ability.rules.length === 0) {
      return '';
   }

   if ((ability.can('read', 'chart') && ability.can('read', subject('overviewTab', { userId: -1 }))) || ability.can('read', 'kpiArea')) {
      return '/dashboard/overview';
   }
   if (ability.can('read', subject('footprint', {}))) {
      return '/dashboard/emissions';
   }
   return '';
}

type RouteBuilder = (...params: string[]) => string;

interface RouteRedirectProps {
   to: RouteBuilder;
   params: string[];
   replace?: boolean;
   fallback?: string; // optional fallback if any param is missing
}

export const RouteRedirect = ({ to, params, replace = true, fallback = '/' }: RouteRedirectProps) => {
   const urlParams = useParams<Record<string, string | undefined>>();

   const values = params.map((p) => urlParams[p]);
   const missing = values.some((v) => v == null);

   if (missing) {
      return <Navigate replace={replace} to={fallback} />;
   }

   return <Navigate replace={replace} to={to(...(values as string[]))} />;
};

export function determineTaxonomyEntryPath() {
   if (!ability) {
      return '403';
   }
   if (ability.rules.length === 0) {
      return '';
   }

   if (ability.can('read', 'fsli') && ability.can('read', 'taxonomyCriteriaResponse') && ability.can('read', 'businessActivity')) {
      return '/taxonomy/overview';
   }

   if (ability.can('read', 'businessActivity')) {
      return '/taxonomy/businessactivities';
   }

   if (ability.can('read', 'fsli')) {
      return '/taxonomy/financials';
   }

   if (ability.can('read', 'minimumSafeguard')) {
      return '/taxonomy/minimum-safeguards';
   }

   if (ability.can('read', 'taxonomyCriteriaResponse')) {
      return '/taxonomy/evaluation';
   }

   return '';
}

export function determineReportsEntryPath() {
   if (!ability) {
      return '403';
   }
   if (ability.rules.length === 0) {
      return '';
   }

   if (ability.can('read', 'report')) {
      return '/reports/documents';
   }

   if (ability.can('read', 'attachment')) {
      return '/reports/document-hub';
   }

   return '';
}
